<div>


    <div *ngIf="student_profile_stage == 'admission'">


        <app-update-student-admission-details [allCourses]="allCourses" [academicYearList]="academicYearList"
            [departmentList]="departmentList" [batchList]="batchList" [feeCategoryList]="feeCategoryList"
            [hostelList]="hostelCategoryList" [editAdmissionData]="studentDetails"
            [transportRouteList]="transportRouteList" [scholarshipList]="scholarshipTypeList"
            (onUpdate)="handleUpdate($event)"></app-update-student-admission-details>

    </div>


    <div *ngIf="student_profile_stage == 'enrollment'">


        <app-update-student-enrollment-details [allCourses]="allCourses" [studentDetails]="studentDetails"
            [allLeadFeilds]="allLeadFeilds" [users]="fullUser" [userslist]="users"
            (onUpdate)="handleUpdate($event)"></app-update-student-enrollment-details>

    </div>


    <div *ngIf="student_profile_stage == 'application'">


        <app-update-student-application-status [allCourses]="allCourses" [studentDetails]="studentDetails"
            [allLeadFeilds]="allLeadFeilds" [users]="fullUser" [userslist]="users"
            (onUpdate)="handleUpdate($event)"></app-update-student-application-status>

    </div>


      <div *ngIf="student_profile_stage == 'registration'">


        <app-update-student-registration-profile [allCourses]="allCourses" [studentDetails]="studentDetails"
            [allLeadFeilds]="allLeadFeilds" [users]="fullUser" [userslist]="users"
            (onUpdate)="handleUpdate($event)"></app-update-student-registration-profile>

    </div>


</div>